import { css } from '@emotion/react';

export const imageSlideWrapper = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  columnGap: '40px'
});

export const imageWrapper = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '680px'
});
export const image = css({
  display: 'none',
  maxWidth: '900px',
  height: '100%',
  objectFit: 'contain'
});
export const imageLoaded = css({
  display: 'initial'
});
export const defaultImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'contain'
});
